export default "__VITE_ASSET__C2Dsqw9j__"